import { SORTING_DIRECTION } from 'src/constants/main';
import { IEditPromobanner, IPromobannersFilter, IPromobannersIsValid, PROMOBANNER_SORT_COLUMN } from '../types/promobanners';

export const defaultPromobanner: IEditPromobanner = {
  name: '',
  image: undefined,
  start_date: undefined,
  end_date: undefined,
  category: undefined,
  product: undefined,
  is_shown_as_offer: true,
  timeslots: [],
  active_24_hours: true,
};

export const defaulPromobannerstFilter: IPromobannersFilter = {
  name: undefined,
  end_date: undefined,
  status: undefined,
  is_delete: 0,
  sort_field: PROMOBANNER_SORT_COLUMN.START_DATE,
  sort_dir: SORTING_DIRECTION.DESCENDING,
};

export const defaultPromobannersIsValid: IPromobannersIsValid = {
  name: true,
  image: true,
  start_date: true,
  all: false,
  target: true,
};
